import React from 'react';

import { ChatMessage } from '@common/react/components/Chat/Chat';

import '@common/react/scss/components/forwardMessage.scss';

interface ForwardLastMessageProps {
	message: ChatMessage;
	userId: number | undefined;
}

const ReplyLastMessage: React.FC<ForwardLastMessageProps> = ({ message, userId }) => {
	return (
		<div className="forward-message__last">
			<div className="chat-list__item-last-message">
				{ message.userId === userId ? `You: ${message.text}` : message.text }
			</div>
			<div className="forward-message__last__icon">
				<i className="fa fa-reply" />
			</div>
		</div>
	);
};

export default ReplyLastMessage;
